(() => {
  const TARGET_VARIANT_ID = 52147332022538;
  const GIFT_VARIANT_ID = 52814367621386;
  const BUNDLE_PRODUCT_IDS = new Set([10305202192650, 10305209434378, 10313771942154]);
  const BUNDLE_MINIMUM_QUANTITY = 3;
  const PROMOTION_KEY = 'zyj-dlugo-wzmocnij-serce-2026';
  const PROMOTION_ENDS_AT = Date.parse('2026-12-31T22:59:59Z');
  const ROOT_URL = window.Shopify?.routes?.root || '/';

  if (window.KateFreeGiftPromotion) return;

  let syncing = false;
  let pending = false;
  let timer;

  const route = (path) => `${ROOT_URL.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;

  const request = async (path, options = {}) => {
    const response = await fetch(route(path), {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...(options.headers || {}),
      },
      ...options,
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.description || data.message || 'Nie udało się zaktualizować gratisu w koszyku.');
    }

    return data;
  };

  const getCart = () => request('cart.js');

  const getSectionsToRender = () => {
    const sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', {
        bubbles: true,
        detail: { sections },
      })
    );

    return [...new Set(sections.filter(Boolean))];
  };

  const publishCart = async (mutationState) => {
    const cart = await getCart();
    if (mutationState.sections) cart.sections = mutationState.sections;

    if (window.FoxTheme?.pubsub) {
      window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
        source: 'kate-free-gift',
        cart,
      });
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    }
  };

  const mutateCart = async (path, payload) => {
    const sections = getSectionsToRender();
    const body = { ...payload };

    if (sections.length) {
      body.sections = sections;
      body.sections_url = window.location.pathname;
    }

    const state = await request(path, {
      method: 'POST',
      body: JSON.stringify(body),
    });

    await publishCart(state);
  };

  const isPromotionalGift = (item) =>
    Number(item.variant_id) === GIFT_VARIANT_ID && item.properties?._kate_free_gift === PROMOTION_KEY;

  const reconcile = async () => {
    const cart = await getCart();
    const targetQuantity = cart.items
      .filter((item) => Number(item.variant_id) === TARGET_VARIANT_ID)
      .reduce((sum, item) => sum + item.quantity, 0);
    const giftLines = cart.items.filter(isPromotionalGift);
    const bundleQuantity = cart.items
      .filter((item) => BUNDLE_PRODUCT_IDS.has(Number(item.product_id)) && !isPromotionalGift(item))
      .reduce((sum, item) => sum + item.quantity, 0);
    const bundleDiscountApplies = bundleQuantity >= BUNDLE_MINIMUM_QUANTITY;
    const shouldHaveGift =
      Date.now() <= PROMOTION_ENDS_AT && targetQuantity > 0 && !bundleDiscountApplies;

    if (!shouldHaveGift && giftLines.length) {
      const updates = Object.fromEntries(giftLines.map((item) => [item.key, 0]));
      await mutateCart('cart/update.js', { updates });
      return;
    }

    if (!shouldHaveGift) return;

    if (!giftLines.length) {
      await mutateCart('cart/add.js', {
        items: [
          {
            id: GIFT_VARIANT_ID,
            quantity: 1,
            properties: { _kate_free_gift: PROMOTION_KEY },
          },
        ],
      });
      return;
    }

    if (giftLines.length > 1 || giftLines[0].quantity !== 1) {
      const updates = Object.fromEntries(
        giftLines.map((item, index) => [item.key, index === 0 ? 1 : 0])
      );
      await mutateCart('cart/update.js', { updates });
    }
  };

  const run = async () => {
    if (syncing) {
      pending = true;
      return;
    }

    syncing = true;
    try {
      do {
        pending = false;
        await reconcile();
      } while (pending);
    } catch (error) {
      console.error('[Kate free gift]', error);
    } finally {
      syncing = false;
    }
  };

  const sync = () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(run, 80);
  };

  window.KateFreeGiftPromotion = { sync };

  document.addEventListener('product-ajax:added', sync);
  document.addEventListener('cart:updated', sync);
  window.addEventListener('pageshow', sync);

  if (window.FoxTheme?.pubsub) {
    window.FoxTheme.pubsub.subscribe(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, sync);
  }

  sync();
})();
